var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateQuantity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29285 3.375V6.1875H7.73871V3.375H2.29285ZM2.29285 2.25H7.73871C8.02758 2.25 8.30461 2.36853 8.50887 2.5795C8.71313 2.79048 8.82788 3.07663 8.82788 3.375V6.1875C8.82788 6.48587 8.71313 6.77202 8.50887 6.983C8.30461 7.19397 8.02758 7.3125 7.73871 7.3125H2.29285C2.00398 7.3125 1.72695 7.19397 1.52269 6.983C1.31843 6.77202 1.20368 6.48587 1.20368 6.1875V3.375C1.20368 3.07663 1.31843 2.79048 1.52269 2.5795C1.72695 2.36853 2.00398 2.25 2.29285 2.25Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4617 14.0625H13.7292V9.5625H10.4617V8.4375H13.7292C14.0181 8.4375 14.2951 8.55603 14.4993 8.76701C14.7036 8.97798 14.8184 9.26413 14.8184 9.5625V14.0625C14.8184 14.3609 14.7036 14.647 14.4993 14.858C14.2951 15.069 14.0181 15.1875 13.7292 15.1875H10.4617V14.0625Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.659152 11.25H7.83244L6.42414 9.79537L7.19418 9L9.91711 11.8125L7.19418 14.625L6.42414 13.8296L7.83244 12.375H0.659152V11.25Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0063 3.375V6.1875H13.7292V3.375H11.0063ZM11.0063 2.25H13.7292C14.0181 2.25 14.2951 2.36853 14.4993 2.5795C14.7036 2.79048 14.8184 3.07663 14.8184 3.375V6.1875C14.8184 6.48587 14.7036 6.77202 14.4993 6.983C14.2951 7.19397 14.0181 7.3125 13.7292 7.3125H11.0063C10.7174 7.3125 10.4404 7.19397 10.2361 6.983C10.0318 6.77202 9.91709 6.48587 9.91709 6.1875V3.375C9.91709 3.07663 10.0318 2.79048 10.2361 2.5795C10.4404 2.36853 10.7174 2.25 11.0063 2.25Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateQuantity);
export default __webpack_public_path__ + "static/media/updateQuantity.762cfb0c.svg";
export { ForwardRef as ReactComponent };